import { render } from "./advertisement.vue?vue&type=template&id=6c67dcd3&scoped=true"
import script from "./advertisement.vue?vue&type=script&lang=js"
export * from "./advertisement.vue?vue&type=script&lang=js"

import "./advertisement.vue?vue&type=style&index=0&id=6c67dcd3&lang=scss&scoped=true"

import exportComponent from "E:\\量化\\my-websit-ai - 副本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c67dcd3"]])

export default __exports__